
// Get the working url from the config object
import { DEV_AWS, PROD_AWS } from "../../lib/constants";
import { is_local_mode } from "./execute-mode";

const config_to_url = config => {

  if (is_local_mode(config)) {
    return config.dev_url;
  }

  if (config.env === DEV_AWS) {
    return config.base_url;
  }

  if (config.env === PROD_AWS) {
    return "https://" + config.subdomain + "."
      + config.build_info.prod_ca.host_name;
  }

  throw new Error("Undefined runtime", config.env);
};

export { config_to_url };
